import actions from "./actions";
import mutations from "./mutation";

export default {
  namespaced: true,
  state: {
    generalSettings: [],
    finalGradeSettings: [],
    appraisalSettings: [],
    appraisalPeriods: [],
    appraisalApprovalSettings: [],
    appraisalGroups: [],
    archivedAppraisalGroups: [],
    appraisalsAppraisalById: [],
    appraisalApproval: [],
    appraisalsAppraisal: [],
    generalSettingsTotal: null,
    tableLoading: false,
    currentPage: 1,
    perPage: 5,
    searchQuery: "",
    total: 0,
    selectedRow: null,
  },
  actions,
  mutations,
};
